import { render, staticRenderFns } from "./pos-page-container.vue?vue&type=template&id=78cac3ee&scoped=true&"
import script from "./pos-page-container.vue?vue&type=script&lang=ts&"
export * from "./pos-page-container.vue?vue&type=script&lang=ts&"
import style0 from "./pos-page-container.vue?vue&type=style&index=0&id=78cac3ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78cac3ee",
  null
  
)

export default component.exports